import styled from 'styled-components';

import { ButtonContainer } from '../Button/styles';

export const ButtonGroupContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  & > ${ButtonContainer} {
    border-right-width: 0;
    border-radius: 0;
  }
  & > ${ButtonContainer}:first-child {
    border-radius: 0.5rem 0 0 0.5rem;
  }
  & > ${ButtonContainer}:last-child {
    border-right-width: 1px;
    border-radius: 0 0.5rem 0.5rem 0;
  }
`;
